import './App.css';

import NavBar from './Components/_Main/NavBar/NavBar';

function App() {
  return (
    <div className="App">
      <NavBar />
    </div>
  );
}

export default App;
